export default __webpack_public_path__ + "media/zurb/img/playground/grace-hopper-9e626bbe3d18135d01bd77a5b0b6dd59.jpg";